export enum ActionTypes {
  TOASTERROR = "TOASTERROR",
  TOASTSUCCESS = "TOASTSUCCESS",
  TOASTWARNING = "TOASTWARNING",
  TOASTCLEAR = "TOASTCLEAR",
}
